import { FC } from 'react';

import { VersionHistoryFileFieldsFragment } from '../../graphql/generated';
import { formatAbbreviatedTimestamp } from '../../utils/date/date';
import { Placeholder } from '../file-browser/file-browser';

type Props = {
  object: VersionHistoryFileFieldsFragment;
};

export const CreatedAt: FC<Props> = ({ object }) => {
  return object.createdAt ? (
    <>{formatAbbreviatedTimestamp(object.createdAt)}</>
  ) : (
    <Placeholder />
  );
};
